import React from 'react'
import image from '../../friends.svg'
import { Card, Form, Button, Image, Spinner } from 'react-bootstrap'
import "../../App.css"

export default function NotLoggedIn({setname, submitname, isvalidated, isLoading}) {
   console.log(isLoading);
  return (
    <Card style={{ alignItems: "center", padding: "15px", marginTop: "10px"}} className="mx-auto card__">
  {isLoading ? <Spinner animation="border" role="status" style={{ height: "75px", borderWidth: "7px", width: "75px" }}>
  <span className="visually-hidden">Loading...</span>
</Spinner> :
    <>
  <Card.Body style={{ fontWeight: "900", fontSize: "32px", textAlign: "center", paddingBottom: "0px" }}>Secret Message Challenge!</Card.Body>
  <Card.Body style={{ fontSize: "35px", textAlign: "center", paddingTop: "5px", paddingBottom: "2px" }}>🔥</Card.Body>
  <Image src={image} style={{ maxWidth: "300px" }} />
  <Card style={{ width: "100%", padding: "20px", marginTop: "10px" }}>
  <form style={{ width: "100%" }}>
  <Card.Body style={{ fontWeight: "900", fontSize: "22px", color: "rgb(95, 95, 98)" , textAlign: "center", paddingBottom: "0px", paddingTop: "0px" }}>👇 Enter Your Name 👇</Card.Body>
  <Form.Control onChange={value => setname(value.target.value)} placeholder="Enter your name here" type="name" style={{ border: "3px #7F7CAF solid", textAlign: "center" }} />
  {isvalidated ? <Form.Text style={{ color: "#dc3545", textAlign: "center" }}>Your name should be longer than 1 character</Form.Text> : <></>}
  <Button type='submit' style={{marginTop: "5px", width: "100%", background: "#7F7CAF", border: "none" }} onClick={(e) => {submitname(e)}}>Next 😎</Button>
  </form>
  </Card>
  </>
}
</Card>
  )
}
